import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { postSubscribe } from 'utils/apiClient';

import TextField from './TextField';
import useRecaptcha from './useRecaptcha';

export default function SubscriptionForm() {
  const { t } = useTranslation();
  const mutation = useMutation(postSubscribe);
  const { executeRecaptcha } = useRecaptcha();

  const [email, setEmail] = useState('');

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const captchaToken = await executeRecaptcha('contact');

    mutation.mutate({ email, captchaToken });
  };

  if (mutation.isError) {
    return (
      <div className="mx-auto max-w-md text-center text-lg">
        {t('an_error_occured')}
      </div>
    );
  }

  if (mutation.isSuccess) {
    return (
      <div className="mx-auto max-w-md text-center text-lg">
        {t('subscription_form_submitted')}
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-auto flex-col items-center space-y-4 md:flex-row md:space-y-0 md:space-x-4"
    >
      <TextField
        required
        type="email"
        placeholder={t('your_email')}
        value={email}
        onChange={handleChangeEmail}
        disabled={mutation.isLoading}
      />
      <button
        type="submit"
        className="btn-primary"
        disabled={mutation.isLoading}
      >
        {mutation.isLoading ? '...' : t('subscribe_yourself')}
      </button>
    </form>
  );
}
